<div [title]="$label()" class="cm-label">{{ $label() }}</div>
<div [hidden]="$connected()" class="cm-vector-inputs">
    <cm-scalar-input-socket
        [label]="'X'"
        [range]="$range()"
        [hideBarFill]="true"
        [connected]="$connected()"
        [value]="$value()?.x"
        (valueChange)="updateValue('x', $event ?? 0)"
        type="input"
    >
    </cm-scalar-input-socket>
    <cm-scalar-input-socket
        [label]="'Y'"
        [range]="$range()"
        [hideBarFill]="true"
        [connected]="$connected()"
        [value]="$value()?.y"
        (valueChange)="updateValue('y', $event ?? 0)"
        type="input"
    >
    </cm-scalar-input-socket>
    <cm-scalar-input-socket
        [label]="'Z'"
        [range]="$range()"
        [hideBarFill]="true"
        [connected]="$connected()"
        [value]="$value()?.z"
        (valueChange)="updateValue('z', $event ?? 0)"
        type="input"
    >
    </cm-scalar-input-socket>
</div>
